import React from 'react';
import PropTypes from 'prop-types';
import { IO_ICONS } from './ioIcons';
import './aiChatModule.scss';

/**
 * Circular floating action button that opens the io Genie chat panel.
 * Idle: 85% opacity + gentle shadow. Hover: full opacity, slight rise,
 * and an "Ask io Genie" tooltip (Zeplin FAB Placement & Trigger).
 *
 * @param {Object} props - Component props.
 * @param {Function} props.onClick - Click handler to toggle AI chat.
 * @param {boolean} [props.isActive] - Whether the chat panel is open.
 * @param {boolean} [props.disabled] - Disables the button when true.
 * @return {JSX.Element} The floating io Genie FAB.
 */
function AiModeButton({ onClick, isActive = false, disabled = false }) {
	return (
		<button
			type="button"
			className={`ai-mode-btn${isActive ? ' ai-mode-btn--active' : ''}`}
			data-hfcl-chat-fab="true"
			onClick={onClick}
			disabled={disabled}
			aria-label="Ask io Genie"
			aria-pressed={isActive}
			aria-hidden={isActive}
			tabIndex={isActive ? -1 : 0}
		>
			<img
				src={IO_ICONS.fab}
				alt=""
				className="ai-mode-btn__icon"
				width={56}
				height={56}
				draggable={false}
				aria-hidden="true"
			/>
			<span className="ai-mode-btn__tooltip" aria-hidden="true">
				Ask io Genie
			</span>
		</button>
	);
}

AiModeButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	isActive: PropTypes.bool,
	disabled: PropTypes.bool,
};

export default AiModeButton;
